import { render, staticRenderFns } from "./AskAgentTransfer.vue?vue&type=template&id=fa4afa42&scoped=true"
import script from "./AskAgentTransfer.vue?vue&type=script&lang=js"
export * from "./AskAgentTransfer.vue?vue&type=script&lang=js"
import style0 from "./AskAgentTransfer.vue?vue&type=style&index=0&id=fa4afa42&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4afa42",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QToolbar,QAvatar,QIcon,QToolbarTitle,QSeparator,QCardSection,QSpinnerIos,QItemSection,QList,QCardActions,QBtn});
